import { toast } from '@systemeio/ui'
import { BadRequest } from '@systemeio/util'
import { CONTACT_API } from 'modules/contacts/api/contact-api'
import { transformContactsImportFileDataForFrontend } from 'modules/contacts/contacts-import/hook/use-get-preview-of-import-contacts-table/utils'
import { ContactsImportDelimiter } from 'modules/contacts/contacts-import/types/contacts-import-delimeter-type'
import { ContactsImportFileDataBackendType } from 'modules/contacts/contacts-import/types/contacts-import-file-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export function useGetPreviewOfImportContactsTable() {
  const { fetcher, isFetching } = useFetch<
    RequestMethodsEnum.postForm,
    ContactsImportFileDataBackendType
  >({
    method: RequestMethodsEnum.postForm,
  })

  return {
    fetcherGetPreviewOfImportContactsTable: async ({
      file,
      delimiter,
    }: {
      file: File
      delimiter: ContactsImportDelimiter
    }) => {
      try {
        const formData = { importFile: file, delimiter }
        const data = await fetcher(`${CONTACT_API}/contacts/import/preview`, formData)
        return transformContactsImportFileDataForFrontend({ dataFromBackend: data })
      } catch (e) {
        if (e instanceof BadRequest) {
          if (e.errors.fields.importFile) toast.error(e.errors.fields.importFile.join())
        }
        throw e
      }
    },
    isGetPreviewOfImportContactsTableFetching: isFetching,
  }
}
